import { Company } from '@/@types/company'

import { getUserInfo } from '../user/get-user-info'

export async function fetchUserChainAgency(): Promise<Company | null> {
  const { data } = await getUserInfo()

  if (!data) {
    return null
  }

  const chainAgency = data.find((company) => {
    return company.companyTypeCode === 'AGENCY_CHAIN'
  })

  if (chainAgency) {
    return {
      ...chainAgency,
      contactData:
        !chainAgency.contactData ||
        JSON.stringify(chainAgency.contactData) === '{}'
          ? undefined
          : chainAgency.contactData,
      addressData:
        !chainAgency.addressData ||
        JSON.stringify(chainAgency.addressData) === '{}'
          ? undefined
          : chainAgency.addressData,
      responsibleData:
        !chainAgency.responsibleData ||
        JSON.stringify(chainAgency.responsibleData) === '{}'
          ? undefined
          : chainAgency.responsibleData,
    }
  }

  return null
}
